module.exports = __webpack_public_path__ + "img/preview3.13f783c9.png";